import React from "react";
import styled from "styled-components";

const StyledCardBody = styled.div``;

const CardBody = ({ children }) => <StyledCardBody>{children}</StyledCardBody>;

export default CardBody;
